import { defineComponent as _defineComponent } from 'vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'UnpairedDatasetElementView',
    props: {
        element: null
    },
    emits: ["element-is-selected"],
    setup(__props, { emit }) {
        return { __sfc: true, emit };
    }
});
